import { Locality, CModelRepo } from "@services/cmodel.repo";
import { SecurityDetails } from "@models/simulations/securityDetails";
import {
  AssetClassNames,
  FixedIncomeTypeNames,
} from "@common/enums/AssetClassType";

class SecurityDialogContoller implements angular.IOnInit {
  public locality: Locality;
  public filteredSecurities: SecurityDetails[];

  public securities: SecurityDetails[];
  public security: SecurityDetails;

  public securitiesPromise: Promise<void>;
  public securityFilter: string;
  public specificAssetClass: string;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private cModelRepo: CModelRepo
  ) {}

  $onInit(): void {
    if (this.specificAssetClass) {
      let promise = this.cModelRepo.getSecurityItemsList(
        this.specificAssetClass,
        this.locality,
        true
      );
      this.securitiesPromise = Promise.all([promise])
        .then(([securities]) => securities)
        .then((securities) => {
          securities.sort((s1, s2) =>
            s1.description > s2.description ? 1 : -1
          );
          this.securities = securities.filter(
            (c) =>
              !this.filteredSecurities.find(
                (f) =>
                  f.name === c.name &&
                  f.description === c.description &&
                  f.isin === c.isin
              )
          );
        });
    } else {
      const equitiesPromise = this.cModelRepo.getSecurityItemsList(
        AssetClassNames.EQUITY,
        this.locality,
        true
      );
      const alternativesPromise = this.cModelRepo.getSecurityItemsList(
        AssetClassNames.ALTERNATIVE_INV,
        this.locality,
        true
      );
      const metalsPromise = this.cModelRepo.getSecurityItemsList(
        AssetClassNames.PRECIOUS_METALS,
        this.locality,
        true
      );
      const fixedIncomeBondPromise = this.cModelRepo.getSecurityItemsList(
        FixedIncomeTypeNames.BOND,
        this.locality,
        true
      );
      const fixedIncomeFundPromise = this.cModelRepo.getSecurityItemsList(
        FixedIncomeTypeNames.FUND,
        this.locality,
        true
      );
      const fixedIncomeDepositPromise = this.cModelRepo.getSecurityItemsList(
        FixedIncomeTypeNames.DEPOSIT,
        this.locality,
        true
      );

      this.securitiesPromise = Promise.all([
        equitiesPromise,
        alternativesPromise,
        metalsPromise,
        fixedIncomeBondPromise,
        fixedIncomeFundPromise,
        fixedIncomeDepositPromise,
      ])
        .then(
          ([
            equities,
            alternatives,
            metals,
            bondIncomes,
            fundIncomes,
            depositIncomes,
          ]) =>
            equities
              .concat(alternatives)
              .concat(metals)
              .concat(bondIncomes)
              .concat(fundIncomes)
              .concat(depositIncomes)
        )
        .then((securities) => {
          securities.sort((s1, s2) =>
            s1.description > s2.description ? 1 : -1
          );
          this.securities = securities.filter(
            (c) =>
              !this.filteredSecurities.find(
                (f) =>
                  f.name === c.name &&
                  f.description === c.description &&
                  f.isin === c.isin
              )
          );
        });
    }
  }

  areSecuritiesLoading() {
    return this.securitiesPromise;
  }

  selectSecurity() {
    this.$mdDialog.hide(this.security);
  }

  closeDialog() {
    this.$mdDialog.cancel();
  }
}

export const SecurityDialog: angular.IComponentOptions = {
  controller: SecurityDialogContoller,
  template: require("./security.dialog.html"),
  bindings: {
    locality: "<",
    filteredSecurities: "<",
    specificAssetClass: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/tradeRecommendations/security.dialog.ts